import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/** Install ASTRONATLAS as a PWA. Listens for beforeinstallprompt and shows a
 * dismissible cyan pill in the bottom-right corner. Hidden after install. */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("sat_pwa_dismissed") === "1");
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    if (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) setInstalled(true);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || dismissed || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome !== "accepted") localStorage.setItem("sat_pwa_dismissed", "1");
    setDeferred(null);
  };
  const dismiss = () => { localStorage.setItem("sat_pwa_dismissed", "1"); setDismissed(true); };

  return (
    <div className="fixed bottom-6 right-6 z-50 sat-surface sat-brackets p-4 max-w-xs sat-box-glow"
      data-testid="pwa-install-prompt">
      <div className="flex items-start gap-3">
        <div className="sat-label sat-cyan mb-1">DIRECTIVE // INSTALL</div>
        <button onClick={dismiss} className="ml-auto text-[color:var(--sat-text-dim)] hover:text-[color:var(--sat-cyan)]"
          data-testid="pwa-install-dismiss" aria-label="Dismiss">
          <X size={14}/>
        </button>
      </div>
      <div className="font-display font-bold text-sm mt-1 mb-3">
        Install ASTRONATLAS for offline access &amp; home-screen launch.
      </div>
      <button onClick={install} className="sat-btn sat-btn-solid w-full justify-center" data-testid="pwa-install-btn">
        <Download size={13}/> INSTALL PWA
      </button>
    </div>
  );
}
